module.exports = __webpack_public_path__ + "static/media/phone.52423f17.png";